module.exports = __webpack_public_path__ + "img/smc-logo-white-small.e058caf4.svg";